import Vue from 'vue'

interface TabTalk extends Vue {
  $broadcast(...args: any[]): void
}

const key = '$$tabtalk'
const tabtalk: TabTalk = new Vue()

const originalEmit = tabtalk.$emit

tabtalk.$emit = function (...args) {
  localStorage.setItem(key, JSON.stringify(args))
  localStorage.removeItem(key)
  return originalEmit.apply(tabtalk, args)
}

tabtalk.$broadcast = function (...args: any[]) {
  localStorage.setItem(key, JSON.stringify(args))
  localStorage.removeItem(key)
}

window.addEventListener('storage', e => {
  if (e.key === key && e.newValue !== null && e.newValue !== undefined) {
    try {
      const value = JSON.parse(e.newValue)
      originalEmit.apply(tabtalk, value)
    } catch (e) {
      console.error(e)
    }
  }
})

export default tabtalk
